import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AuthService, User } from '@app/services/auth/auth.service';
import { PopupsService } from '@voyagu/portal-design-system';
import { SignInModalService } from '@app/services/sign-in-modal.service';
import { PortalRoutes } from '@app/app-routing.module';
import { AuthorizedDataService } from '@app/services/authorized-data/authorized-data.service';
import { ReferralProgramService } from '@app/services/referral-program/referral-program.service';
import { map } from 'rxjs';

@Component({
  selector: 'home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageComponent implements OnInit {
  PortalRoutes = PortalRoutes;

  destroyRef = inject(DestroyRef);
  authService = inject(AuthService);
  popupsService = inject(PopupsService);
  signInModalService = inject(SignInModalService);
  authorizedDataService = inject(AuthorizedDataService);
  referralProgramService = inject(ReferralProgramService);

  authorizedData$ = this.authorizedDataService.getAuthorizedData();
  referralProgram$ = this.referralProgramService
    .getState()
    .pipe(map((state) => (state.status === 'ready' ? state.data : null)));

  email: string;

  nextTripModel = {
    'planning-trip': {
      cabinClass: '',
      leavingFrom: '',
      range: { from: '', to: '' },
      travellingTo: '',
    },
  };

  user$: Subject<User | null>;

  @ViewChild('startPlanningTemplate') startPlanningTemplate: TemplateRef<unknown>;
  @ViewChild('tripPlanningModal') tripModal: TemplateRef<unknown>;

  ngOnInit() {
    this.user$ = this.authService.user$;

    this.authService
      .hasSession()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((hasSession) => {
        if (!hasSession) {
          this.signInModalService.showModal(true);
        }
      });
  }

  startPlanning() {
    this.popupsService.showModalWithFullHeightMobile(this.tripModal, 48);
  }

  hideModal(): void {
    this.popupsService.hideLast();
  }
}
